export default __webpack_public_path__ + "static/media/astro.fa555561.png";